// extracted by mini-css-extract-plugin
export var chip = "_a4-0";
export var filterDropdown = "_a4-5";
export var filterItem = "_a4-6";
export var icon = "_a4-1";
export var removeButton = "_a4-3";
export var removeIcon = "_a4-4";
export var separator = "_a4-2";